/**
 * HatLegsTrackingTile.mask.ts
 *
 * Data-masking logic for HatLegsTrackingTile (HAT + GAR tracking).
 * When showData is false, display values are replaced with "--"
 * so no real performance data is visible.
 */

const MASKED_VALUE = "--";

export const maskHatGarValue = (value: number | string, showData: boolean): number | string =>
  showData ? value : MASKED_VALUE;
